import { Button, CircularProgress } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { Component, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { enrolledCount, getEnrolledCredentials } from '../../../modules/authmethods';

import OobBioEnroll from './OobBioEnroll';
import OobPhoneEnroll from './OobPhoneEnroll';
import OobSmsEnroll from './OobSmsEnroll';
import QuestionsEnroll from './QuestionsEnroll';
import { Redirect } from 'react-router-dom';
import TrxSignEnroll from './TrxSignEnroll';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { logout } from '../../../modules/auth';
import { push } from 'connected-react-router';
import PushOtpEnroll from './PushOtpEnroll';

const styles = (theme: Theme) => createStyles({
  root: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    maxWidth: '45rem',
  },
  progress: {
    margin: '5rem auto',
  },
  heading: {
    marginLeft: theme.spacing(1),
  },
  authHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
}
)

class Enrollment extends Component<Props, { expanded: number, error: string, loading: boolean }> {
  state = {
    expanded: 0,
    error: "",
    loading: true,
  }

  componentDidMount() {
    this.props.getEnrolledCredentials()
      .then((response: any) => this.setState({ loading: false }))
  }

  handleExpansionChange = (panel: number) => (expanded: boolean) => {
    this.setState({
      expanded: expanded ? panel : -1,
    });
  }

  expandNext = () => {
    this.setState(prevState => ({
      expanded: prevState.expanded + 1
    }))
  }

  handleLogout = () => {
    this.props.logout().then(d => push('/'))
  }

  render = () => {
    const { classes, showLogout, next, enrolledCount } = this.props;
    const { loading } = this.state

    if (!this.props.auth.authenticated) {
      return <Redirect to="/" />
    }

    return (
      <div className={classNames(classes.root)}>
        {loading ?
          <CircularProgress className={classes.progress} />
          : <Fragment>
            <QuestionsEnroll expanded={this.state.expanded === 0} setExpanded={this.handleExpansionChange(0)} expandNext={this.expandNext} />
            <OobPhoneEnroll expanded={this.state.expanded === 1} setExpanded={this.handleExpansionChange(1)} expandNext={this.expandNext} />
            <OobSmsEnroll expanded={this.state.expanded === 2} setExpanded={this.handleExpansionChange(2)} expandNext={this.expandNext} />
            <OobBioEnroll expanded={this.state.expanded === 3} setExpanded={this.handleExpansionChange(3)} expandNext={this.expandNext} />
            <PushOtpEnroll expanded={this.state.expanded === 4} setExpanded={this.handleExpansionChange(4)} expandNext={this.expandNext} />
            <TrxSignEnroll expanded={this.state.expanded === 4} setExpanded={this.handleExpansionChange(4)} expandNext={this.expandNext} />
          </Fragment>
        }

        <div style={{ marginTop: '1rem', marginBottom: '2rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          {showLogout ?
            <Button color="default" onClick={this.handleLogout}>Logout</Button>
            : ""
          }
          {!loading && next &&
            <Button variant="contained" disabled={enrolledCount() === 0} color="primary" onClick={next}>Next</Button>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth, authmethods, intl }: IStoreState) => ({
  auth,
  authmethods,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      push,
      logout,
      getEnrolledCredentials,
      enrolledCount
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  showLogout?: boolean
  next?: () => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Enrollment));